import React from 'react';

import { Switch, Route } from 'react-router-dom';

import { Home } from './Home';
import { Result } from './Result';
import { NewClinic } from './NewClinic';
// import { Login } from './Login';
import { Profile } from './Profile';
import { ProfessionalProfile } from './ProfessionalProfile';
import { ComponentError } from './ComponentError';
// import { Terms } from './Terms';
// import { Privacy } from './Privacy';
import { UpcomingAppointment } from './UpcomingAppointment';
import { PastAppointment } from './PastAppointment';
import { Favourite } from './Favourite';
import { Settings } from './Settings';
import { ExpertColumn } from './ExpertColumn';
import { ExpertColumnDetail } from './ExpertColumnDetail';
import { Specialties } from './Specialties';
import { Services } from './Services';
import { Locations } from './Locations';
import { GenericNotFound } from './errors/GenericNotFound';

const Main = () => {
    return (
        <Switch>
            <Route exact path='/search-book' component={Home}></Route>
            <Route exact path='/search-book/result' component={Result}></Route>
            <Route exact path='/search-book/clinic/:location_friendly_id' component={NewClinic}></Route>
            {/* <Route exact path='/search-book/login' component={Login}></Route> */}
            <Route exact path='/search-book/profile' component={Profile}></Route>
            <Route exact path='/search-book/professional-profile/:doc_friendly_id/:location_friendly_id' component={ProfessionalProfile}></Route>
            {/* <Route exact path='/search-book/terms' component={Terms}></Route>
            <Route exact path='/search-book/privacy' component={Privacy}></Route> */}
            <Route exact path='/search-book/upcoming-appointment' component={UpcomingAppointment}></Route>
            <Route exact path='/search-book/past-appointment' component={PastAppointment}></Route>
            <Route exact path='/search-book/favourites' component={Favourite}></Route>
            <Route exact path='/search-book/settings' component={Settings}></Route>
            <Route exact path='/search-book/expert-column' component={ExpertColumn}></Route>
            <Route exact path='/search-book/expert-column/:id' component={ExpertColumnDetail}></Route>
            <Route exact path='/search-book/specialties' component={Specialties}></Route>
            <Route exact path='/search-book/services' component={Services}></Route>
            <Route exact path='/search-book/locations' component={Locations}></Route>
            <Route path='/search-book/404' component={GenericNotFound} />
            <Route component = { ComponentError } />
        </Switch>
    );
}

export { Main };
